import { COLORS } from '@constants';
import { Button } from '@ui';
import { Card } from 'antd';
import styled from 'styled-components';

export const StyledWrapper = styled(Card)`
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 101;
    transform: translate(-50%, -50%);
    width: calc(100% - 80px);
    max-width: 630px;
    background-color: ${COLORS.$gray10Black};
`;

export const StyledMask = styled.div`
    z-index: 100;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.7);
    inset: 0;
`;

export const StyledCloseButton = styled(Button)`
    &&& {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 101;
        cursor: pointer;
        padding: 0;
        height: initial;
        border: 0;
        opacity: 0;

        svg {
            width: 24px;
            height: 24px;
        }

        &:hover {
            background-color: transparent;
        }
    }
`;
